/* eslint-disable no-console */
import { mapState } from 'vuex';
import Konva from 'konva'
import { TimelineMax, Power1 } from 'gsap/dist/gsap'
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import ApiHelper from "@/helpers/ApiHelper";
import ErrorHelper from "@/helpers/ErrorHelper";
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue";
import oButton from "@/objects/o-button/o-button.vue";
import oModal from "@/objects/o-modal/o-modal.vue";

export default {
  name: "vInvent",
  components: {
    "layout-green-screen": LayoutGreenScreen,
    "o-button": oButton,
    "o-modal": oModal
  },
  data() {
    return {
      mediaStream: null,
      stage: null,
      layerDrawing: null,
      layerVideo: null,
      width: null,
      height: null,
      canvasWidth: null,
      canvasHeight: null,
      imageWidth: null,
      imageHeight: null,
      videoWidth: null,
      videoHeight: null,
      video: null,
      videoContext: null,
      tempVideo: null,
      tempVideoContext: null,
      chromakeyedVideo: null,
      chromaKeyColor: null,
      chromaKeySensitivity: null,
      computeInterval: null,
      showModalStop: false,
      showTimer: false,
      timeToPhoto: 10,
      started: false
    }
  },
  methods: {
    fetchData(locale) {
      ApiHelper
            .get(
              CONST.API.ROUTE.CONTENT + locale, { server: 'blockrocker_cms' }
            )
            .then((res) => {
              this.$store.commit('updateContent', { data: res.data.data, locale })
            })
    },
    async start() {
      this.started = true;

      this.cleanUp();
      await new Promise((r) => setTimeout(r, 1000))
      this.initializeVideo();
      this.initializeCanvas(this.$store.getters.currentDrawing);
    },
    stop() {
      eventBus.$emit(CONST.EVENT.INVENTION.STOPPED);

      this.showModalStop = false;
    },
    cleanUp() {
      this.stopVideo();

      // clean up canvas
      this.stage = null;
      this.layerDrawing = null;
      this.layerVideo = null;
      this.video = null;
      this.chromakeyedVideo =  null;
      this.videoContext = null;
      this.tempVideo = null;
      this.tempVideoContext = null;
      this.mediaStream = null;
      
      if (document.getElementById('container-canvas')) {
        const canvas = document.getElementById('container-canvas');
        canvas.innerHTML = '';
      }
    },
    animate(ell, {from: from, to: to, duration: duration}) {
      const tl1 = new TimelineMax();

      tl1.add('enter')
      tl1.fromTo(
        ell,
        duration,
        {
          opacity: from
        },
        {
          opacity: to,
          ease: Power1.out
        },
        'enter'
      )
    },
    exportImage() {
      let _this = this;

      // remove handles
      this.stage.find('Circle').hide();
      this.stage.find('Line').hide();
      this.layerDrawing.draw();

      // export image
      let dataUrl = this.stage.toDataURL();
      this.$store.commit('invention', dataUrl);

      fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => _this.submitImage(blob)
      )
    },
    submitImage(blob) {
      const formData = new FormData();
      formData.append("file", blob);

      ApiHelper.post(CONST.API.ROUTE.INVENTION.CREATE, formData, {headersType: 'multipart'})
      .then(response => {
        let image_url = response.data.url.split("http://res.cloudinary.com/dy9kphxmp/image/upload/")[1];
        let image_id = image_url.substring(0, image_url.length - 4);

        this.$store.commit('inventionId', image_id);

        this.cleanUp();

        this.$router.push({ name: 'invention-ready'});
      })
      .catch(error => {
          ErrorHelper.catch(error, this);
      });
    },
    setPhotoTimer() {
      const _this = this;

      this.showTimer = true;

      let interval = setInterval(function(){
        _this.timeToPhoto--;

        if(_this.timeToPhoto == -1) {
          clearInterval(interval);

          _this.showTimer = false;
          _this.takePhoto();
        }
      }, 1000);
    },
    takePhoto() {
      const _this = this;

      document.getElementById('photo-splash').style.display = 'block';

      this.animate(document.getElementById('photo-splash'), {from: 1, to: 0, duration: 0.5});

      setTimeout(function(){ _this.exportImage(); }, 500);
    },
    async initializeVideo() {
      if(!this.mediaStream) {
        this.mediaStream = await navigator.mediaDevices.getUserMedia({video: true});
        const video = document.getElementById('video');
        video.srcObject = this.mediaStream;
      }
    },
    stopVideo() {
      if(this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop());
      }
    },
    initializeCanvas(src) {
      const _this = this;

      this.chromaKeyColor = this.$store.getters.chromaKeyColorRGBArray;
      this.chromaKeySensitivity = this.$store.state.chroma_key_sensitivity;

      this.video = document.getElementById('video');
      this.chromakeyedVideo =  document.getElementById('chromakeyedVideo')
      this.videoContext = this.chromakeyedVideo.getContext('2d');
      this.videoContext.width = this.videoWidth;
      this.videoContext.height = this.videoHeight;
      this.tempVideo = document.getElementById('tempChromakeyedVideo');
      this.tempVideoContext = document.getElementById('tempChromakeyedVideo').getContext('2d');
      this.tempVideoContext.width = this.videoWidth;
      this.tempVideoContext.height = this.videoHeight;

      this.stage = new Konva.Stage({
        container: 'container-canvas',
        width: this.canvasWidth,
        height: this.canvasHeight
      });

      this.layerDrawing = new Konva.Layer();
      this.layerVideo = new Konva.Layer();
      this.stage.add(this.layerDrawing);
      this.stage.add(this.layerVideo);

      // drawing
      let drawing = new Konva.Image({
        width: this.imageWidth,
        height: this.imageHeight
      });

      let drawingGroup = new Konva.Group({
        x: 180,
        y: 50,
        draggable: true
      });
      this.layerDrawing.add(drawingGroup);
      drawingGroup.add(drawing);
      this.addLine(drawingGroup, 0, 0, this.imageWidth, 0, 'lineTop', false);
      this.addLine(drawingGroup, this.imageWidth, 0, this.imageWidth, this.imageHeight, 'lineRight', false);
      this.addLine(drawingGroup, 0, this.imageHeight, this.imageWidth, this.imageHeight, 'lineBottom', false);
      this.addLine(drawingGroup, 0, 0, 0, this.imageHeight, 'lineLeft', false);
      this.addAnchor(drawingGroup, 0, 0, 'topLeft');
      this.addAnchor(drawingGroup, this.imageWidth, 0, 'topRight');
      this.addAnchor(drawingGroup, this.imageWidth, this.imageHeight, 'bottomRight');
      this.addAnchor(drawingGroup, 0, this.imageHeight, 'bottomLeft');

      let imageObj = new Image();
      imageObj.onload = function () {
        drawing.image(imageObj);
        _this.layerDrawing.draw();
      };
      // 'https://www.w3schools.com/w3css/img_lights.jpg'
      imageObj.crossOrigin = 'Anonymous';
      imageObj.src = src;

      // video
      let video = new Konva.Image({
        image: this.chromakeyedVideo
      });

      let videoGroup = new Konva.Group({
        x: 50,
        y: 20,
        draggable: true
      });
      this.layerVideo.add(videoGroup);
      videoGroup.add(video);

      if(!this.computeInterval) {
        this.computeInterval = setInterval(function(){
          if(_this.layerVideo) {
            _this.computeFrame();
            _this.layerVideo.draw();
          }

        }, 50);
      }

      document.getElementById('video').addEventListener('loadedmetadata', function () {
        _this.videoWidth = document.getElementById('video').videoWidth;
        _this.videoHeight = document.getElementById('video').videoHeight;

        video.width(_this.videoWidth);
        video.height(_this.videoHeight);

        _this.chromakeyedVideo.width = _this.videoWidth;
        _this.chromakeyedVideo.height = _this.videoHeight;
        _this.tempVideo.width = _this.videoWidth;
        _this.tempVideo.height = _this.videoHeight;

        _this.addLine(videoGroup, 0, 0, _this.videoWidth, 0, 'videoLineTop', false);
        _this.addLine(videoGroup, _this.videoWidth, 0, _this.videoWidth, _this.videoHeight, 'videoLineRight', false);
        _this.addLine(videoGroup, 0, _this.videoHeight, _this.videoWidth, _this.videoHeight, 'videoLineBottom', false);
        _this.addLine(videoGroup, 0, 0, 0, _this.videoHeight, 'videoLineLeft', false);
      });
    },
    computeFrame: function() { // chromakey
      if(this.videoWidth > 0) {
        let frame = '';
        let backgroundFrame = null;
        let data = null;
        let l;
        let r; let g; let b;

        this.tempVideoContext.drawImage(this.video, 0, 0)

        frame = this.tempVideoContext.getImageData(0, 0, this.videoWidth, this.videoHeight)
        data = frame.data

        backgroundFrame = this.videoContext.getImageData(0, 0, this.videoWidth, this.videoHeight)

        l = data.length / 4
        while (l--) {
          r = data[l * 4]
          g = data[l * 4 + 1]
          b = data[l * 4 + 2]

          if (Math.abs(r - this.chromaKeyColor[0]) < this.chromaKeySensitivity &&
                Math.abs(g - this.chromaKeyColor[1]) < this.chromaKeySensitivity &&
                Math.abs(b - this.chromaKeyColor[2]) < this.chromaKeySensitivity) {
            frame.data[l * 4] = backgroundFrame.data[l * 4]
            frame.data[l * 4 + 1] = backgroundFrame.data[l * 4 + 1]
            frame.data[l * 4 + 2] = backgroundFrame.data[l * 4 + 2]
            frame.data[l * 4 + 3] = 0
          }
        }

        this.videoContext.putImageData(frame, 0, 0)
      }
    },
    update(activeAnchor) {
      let group = activeAnchor.getParent();

      let topLeft = group.find('.topLeft')[0];
      let topRight = group.find('.topRight')[0];
      let bottomRight = group.find('.bottomRight')[0];
      let bottomLeft = group.find('.bottomLeft')[0];
      let lineTop = group.find('.lineTop')[0];
      let lineRight = group.find('.lineRight')[0];
      let lineBottom = group.find('.lineBottom')[0];
      let lineLeft = group.find('.lineLeft')[0];
      let image = group.find('Image')[0];

      let anchorX = activeAnchor.getX();
      let anchorY = activeAnchor.getY();

      // update anchor positions
      switch (activeAnchor.getName()) {
        case 'topLeft':
          topRight.y(anchorY);
          bottomLeft.x(anchorX);
          break;
        case 'topRight':
          topLeft.y(anchorY);
          bottomRight.x(anchorX);
          break;
        case 'bottomRight':
          bottomLeft.y(anchorY);
          topRight.x(anchorX);
          break;
        case 'bottomLeft':
          bottomRight.y(anchorY);
          topLeft.x(anchorX);
          break;
      }

      lineTop.points([topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY()]);
      lineRight.points([topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY()]);
      lineBottom.points([bottomLeft.getX(), bottomLeft.getY(), bottomRight.getX(), bottomRight.getY()]);
      lineLeft.points([topLeft.getX(), topLeft.getY(), bottomLeft.getX(), bottomLeft.getY()]);

      image.position(topLeft.position());

      let width = topRight.getX() - topLeft.getX();
      let height = bottomLeft.getY() - topLeft.getY();
      if (width && height) {
        image.width(width);
        image.height(height);
      }
    },
    addAnchor(group, x, y, name) {
      const _this = this;

      let layer = group.getLayer();

      let anchor = new Konva.Circle({
        x: x,
        y: y,
        stroke: '#003865',
        fill: '#003865',
        strokeWidth: 2,
        radius: 8,
        name: name,
        draggable: true,
        dragOnTop: false
      });

      anchor.on('dragmove', function () {
        _this.update(this);
        layer.draw();
      });
      anchor.on('mousedown touchstart', function () {
        group.draggable(false);
        this.moveToTop();
      });
      anchor.on('dragend', function () {
        group.draggable(true);
        layer.draw();
      });

      group.add(anchor);
    },
    addLine(group, x_start, y_start, x_end, y_end, name, draggable) {
      let line = new Konva.Line({
        points: [x_start, y_start, x_end, y_end],
        stroke: '#EFEFEF',
        strokeWidth: 4,
        lineJoin: 'round',
        dash: [20, 10],
        draggable: draggable,
        dragOnTop: false,
        name: name
      });

      group.add(line);
    },
    setDimensions() {
      this.canvasWidth = window.innerWidth;
      this.canvasHeight = window.innerHeight - 120;
      this.imageWidth = 1024;
      this.imageHeight = 768;
    }
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    },
    hasDrawings() {
      return this.$store.getters.hasDrawings;
    },
    drawings() {
      return this.$store.state.drawings;
    }
  },
  watch: {
    drawings(arr) {
      // If drawings are added => check if the process needs to start
      if(arr.length > 0) {
        this.$nextTick(() => {
          if(!this.started) {
            this.start();
          }
        })
      }else{
        this.cleanUp();
      }
    }
  },
  mounted() {
    this.setDimensions();

    if(this.$store.getters.hasDrawings) {
      this.$nextTick(() => {
        this.start();
      })
    }

    this.fetchData('nl');
    this.fetchData('de');
    this.fetchData('en');
  }
}
